<template>
  <b-form-group
    label="Kuruluş Yılı"
    label-for="year"
  >
    <validation-provider
      #default="{ errors }"
      name="Kuruluş Yılı"
      rules="required"
    >
      <b-form-input
        id="year"
        v-model="itemData.year"
        placeholder="Kuruluş Yılı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'YearText.',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
